/*
 * @Author: Gaho
 * @Date: 2024-03-12 10:32:13
 * @LastEditors: Gaho
 * @LastEditTime: 2024-03-12 10:38:09
 * @Description: 
 */
import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';

export const useTripleSocket = (rootPath = 'games') => {
    const EMIT_TRIPLE_BET = async (
        data: {
            amount: string;
            frontID?: number;
            risk: string,
            selected: number[],
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return await asyncEmit<{
            roll_number: [];
            winAmount: number;
            [key: string]: any; // 前端将追加其它值
        }>(`${rootPath}.triple.bet`, data);
    };

    return {
        EMIT_TRIPLE_BET,
    };
};
